import Styleguide from './styleguide';

export default Styleguide;
